import { Col, Row } from 'antd';
import React from 'react';
import styled from 'styled-components';

import theme from '../../../assets/theme';
import { Center } from '../../_atoms/Center';
import MaxWidthContainer from '../../_atoms/MaxWidthContainer';

const ImageAndText = ({
  image,
  title,
  description,
  actions,
  direction = 'ltr',
}: {
  image: string;
  title: string;
  description: string;
  actions?: React.ReactNode;
  direction?: 'rtl' | 'ltr';
}) => {
  return (
    <MaxWidthContainerStyled>
      <Row
        gutter={[40, 40]}
        style={{
          paddingTop: 40,
          paddingBottom: 40,
          flexDirection: direction === 'rtl' ? 'row-reverse' : 'row',
        }}
      >
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
          <Center>
            <img style={{ height: '100%', width: '100%' }} src={image} alt="test" />
          </Center>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
          <Center style={{ flexDirection: 'column' }}>
            <div style={{ maxWidth: 420, margin: 'auto' }}>
              <Title>{title}</Title>
              <Description>{description}</Description>
              {actions}
            </div>
          </Center>
        </Col>
      </Row>
    </MaxWidthContainerStyled>
  );
};

const MaxWidthContainerStyled = styled(MaxWidthContainer)`
  img {
    max-width: 420px;
  }

  @media (max-width: 1128px) {
    img {
      max-width: 100%;
    }
  }
`;

const Title = styled.p`
  font-size: 28px;
  font-weight: 500;
  max-width: 420px;
  line-height: 36px;
  width: 100%;
  text-align: center;
  color: ${theme.colors.black};
`;
const Description = styled.p`
  width: 100%;
  max-width: 420px;
  font-size: 22px;
  text-align: center;
  line-height: 36px;
  font-weight: regular;
  color: ${theme.colors.black};
`;

export default ImageAndText;
